import React from 'react'

const JPGIcon = () => {
  return (
    <svg
      width="42"
      height="43"
      viewBox="0 0 42 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_2025_70388"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="42"
        height="43"
      >
        <rect y="0.5" width="42" height="42" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2025_70388)">
        <path
          d="M10.5 39C9.5375 39 8.71383 38.6576 8.029 37.9728C7.343 37.2868 7 36.4625 7 35.5V7.5C7 6.5375 7.343 5.71325 8.029 5.02725C8.71383 4.34242 9.5375 4 10.5 4H24.5L35 14.5V35.5C35 36.4625 34.6576 37.2868 33.9727 37.9728C33.2868 38.6576 32.4625 39 31.5 39H10.5ZM22.75 16.25H31.5L22.75 7.5V16.25Z"
          fill="#E6E7EA"
        />
      </g>
      <rect
        x="4"
        y="20.5"
        width="16.375"
        height="11.25"
        rx="1"
        fill="#F3A66E"
      />
      <path
        d="M7.48426 28.625V27.9609H7.71269C7.88269 27.9609 8.01728 27.9131 8.11644 27.8175C8.21915 27.7183 8.27051 27.5873 8.27051 27.4244V24.6672H8.99832V27.3978C8.99832 27.6422 8.94519 27.8565 8.83894 28.0406C8.73624 28.2248 8.58749 28.3682 8.39269 28.4709C8.20144 28.5736 7.97478 28.625 7.71269 28.625H7.48426ZM9.74514 28.625V24.6672H11.222C11.4912 24.6672 11.7285 24.7168 11.9339 24.8159C12.1428 24.9116 12.3058 25.0532 12.4226 25.2409C12.5395 25.4251 12.598 25.65 12.598 25.9156C12.598 26.1777 12.5377 26.4026 12.4173 26.5903C12.3005 26.7745 12.1393 26.9161 11.9339 27.0153C11.7285 27.1145 11.4912 27.1641 11.222 27.1641H10.4676V28.625H9.74514ZM10.4676 26.5266H11.2326C11.3637 26.5266 11.477 26.5018 11.5726 26.4522C11.6683 26.3991 11.7426 26.3265 11.7958 26.2344C11.8489 26.1423 11.8755 26.036 11.8755 25.9156C11.8755 25.7917 11.8489 25.6854 11.7958 25.5969C11.7426 25.5048 11.6683 25.434 11.5726 25.3844C11.477 25.3312 11.3637 25.3047 11.2326 25.3047H10.4676V26.5266ZM15.0653 28.6888C14.7819 28.6888 14.5199 28.6374 14.279 28.5347C14.0382 28.432 13.8275 28.2885 13.6468 28.1044C13.4662 27.9202 13.3245 27.7042 13.2218 27.4562C13.1227 27.2083 13.0731 26.9374 13.0731 26.6434C13.0731 26.3495 13.1209 26.0785 13.2165 25.8306C13.3157 25.5792 13.4538 25.3631 13.6309 25.1825C13.8115 24.9983 14.0223 24.8567 14.2631 24.7575C14.5039 24.6548 14.766 24.6034 15.0493 24.6034C15.3327 24.6034 15.5859 24.6512 15.809 24.7469C16.0357 24.8425 16.2269 24.97 16.3828 25.1294C16.5386 25.2852 16.6502 25.457 16.7175 25.6447L16.0747 25.9528C16.0003 25.7474 15.8745 25.5809 15.6975 25.4534C15.5204 25.3259 15.3043 25.2622 15.0493 25.2622C14.8014 25.2622 14.5818 25.3206 14.3906 25.4375C14.2029 25.5544 14.0559 25.7155 13.9497 25.9209C13.8469 26.1264 13.7956 26.3672 13.7956 26.6434C13.7956 26.9197 13.8487 27.1623 13.955 27.3712C14.0648 27.5767 14.2153 27.7378 14.4065 27.8547C14.5978 27.9716 14.8174 28.03 15.0653 28.03C15.2672 28.03 15.4531 27.991 15.6231 27.9131C15.7931 27.8317 15.9294 27.7183 16.0322 27.5731C16.1349 27.4244 16.1862 27.2491 16.1862 27.0472V26.7444L16.5156 27.0312H15.0493V26.4203H16.9087V26.8187C16.9087 27.1233 16.8574 27.3925 16.7547 27.6262C16.6519 27.86 16.512 28.0566 16.335 28.2159C16.1614 28.3718 15.9649 28.4904 15.7453 28.5719C15.5257 28.6498 15.299 28.6888 15.0653 28.6888Z"
        fill="white"
      />
    </svg>
  )
}

export default JPGIcon
